export default __webpack_public_path__ + "static/media/2306.3d130170.png";